import { namespace, schema, backendDocType, docPrivilege } from './config'
import { useTranspile } from './common'
import loader, {
  PlanRestorer,
  generateReferenceDoc,
  queryManifest,
} from './loader'
import listview from './listview'
import compareview from './compare'
import composedview from './composed'
import { ticketProfile, useScopeName } from './ticket'
import { addViewManifest } from '../Config'

const manifest = {
  loader,
  schema,
  namespace,
  backendDocType,
  privilege: docPrivilege,
  queryManifest,
  useTranspile,
  generateReferenceDoc,
  restore: PlanRestorer,
  listview,
  compareview,
  composedview,
  ticketProfile,
  useScopeName,
  order: 3,
}

addViewManifest(manifest)
